<template>
  <div class="error-page">
    <img src="../assets/images/black@2x.png">
    <h5>{{ this.message }}</h5>
    <p>{{$t('pageNotFound')}}</p>
    <router-link :to="homeLink" class="btn btn-back" v-show="showBtn">{{$t('goToHomepage')}}</router-link>
  </div>
</template>

<script>
export default {
  name: 'Error',
  data() {
    return {
      message: '',
      showBtn: true,
      homeLink: '/',
    }
  },
  created: function () {
    if (this.$route.redirectedFrom) {
      const redirectedFrom = this.$route.redirectedFrom;
      this.homeLink = redirectedFrom.indexOf('/external/') >= 0 ? '/external/login' : redirectedFrom.indexOf('/security/') >= 0 ? '/security/index' : '/';
    } else if (this.$route.query.redirectedFrom) {
      const redirectedFrom = this.$route.query.redirectedFrom;
      this.homeLink = redirectedFrom.indexOf('/external/') >= 0 ? '/external/login' : redirectedFrom.indexOf('/security/') >= 0 ? '/security/index' : '/';
    }
    
    if (this.$route.query.message == 404) {
      this.message = this.$t('noAccessInterface')
    } else if (this.$route.query.message == 408) {
      this.message = this.$t('requestTimeout')
    } else if (this.$route.query.message == 'Network Error') {
      this.message = this.$t('networkError')
    } else {
      this.message = this.$route.query.message;
      this.showBtn = false;
    }
  },
  methods: {
  }
};
</script>
<style scoped lang="scss">
.btn {
  &:focus,
  &:hover {
    box-shadow: none;
  }
}
.error-page {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  text-align: center;
  img {
    width: 132px;
    margin-bottom: 20px;
    height: auto;
  }
  h5,
  p {
    font-size: 14px;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 242px;
    height: 46px;
    border-radius: 5px;
    font-size: 15px;
    line-height: 32px;
    color: #fff;
    margin-top: 5px;
    background-image: linear-gradient(69deg, #f36443, #e42029);
  }
}
</style>
